import { render, staticRenderFns } from "./statisticStore.vue?vue&type=template&id=fe789ea2&scoped=true"
import script from "./statisticStore.vue?vue&type=script&lang=js"
export * from "./statisticStore.vue?vue&type=script&lang=js"
import style0 from "./statisticStore.vue?vue&type=style&index=0&id=fe789ea2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe789ea2",
  null
  
)

export default component.exports